<div class="modal-body">
  <div class="modal-noticeCanada">
    <div class="modal-noticeCanada--img">
      <img src="./assets/images/USA_Flag.png" alt="Can">
    </div>
    <div class="modal-noticeCanada--h1">
      <span>Requisitos para abordar vuelos hacia Canadá para ciudadanos mexicanos</span>
    </div>

  </div>
  <div class="modal-subtitle">
    <span>Los Requisitos para viajar a Canadá han cambiado</span>
  </div>
  <div class="modal-txt">
    <div class="modal-txt-font">
      <div class="modal-txt-font-firstTxt">
        <span>Si ya cuenta con una autorización electrónica de viaje (eTA), está ya no es válida para viajar. Usted
          puede solicitar una nueva eTA si vuela hacia Canadá o va a estar en tránsito y:</span>
      </div>
      <div>
        <img src="./assets/images/check_blue.svg" alt="check">
        <span class="margin-check-txt">Ha obtenido una visa de visitante canadiense en los últimos 10 años 7/o</span>
      </div>
      <div>
        <img src="./assets/images/check_blue.svg" alt="check">
        <span class="margin-check-txt">Actualmente posee una visa de no inmigrante (NIV) válida para Canadá</span>
      </div>
      <div class="modal-txt-font-thirdTxt">
        <span>Si no reúne los requisitos anteriores, usted ahora necesita una visa para viajar a Canadá. Puede
          solicitarla en línea en <span class="modal-txt-font-thirdTxt--WS">Canada.ca/visit.</span></span>
      </div>
      <div class="modal-txt-font-fourthTxt">
        <span>Si tiene un permiso de trabajo o estudio vigente, estos cambios no le afectarán. Puede seguir viajando a
          Canadá con su eTA actual</span>
      </div>
    </div>
    <div>
      <img src="./assets/images/QR_CAN.png" class="cananda_QR" alt="QR_CAN">
    </div>

  </div>
</div>
<div class="modal-banner">
  <div>
    <img class="img-exclamation" src="./assets/images/exclamation_banner.svg" alt="exclamation">
  </div>
  <div class="modal-banner-txt">
    <span>
      Si el pasajero no cuenta con alguno de estos requisitos se le negará el abordaje a su vuelo.</span>
  </div>
</div>
<div class="modal-footer">
  <div>
    <button (click)="goToInit()" class="btn-cancel">CANCELAR</button>
  </div>
  <div>
    <button (click)="goToFlightInfo()" class="btn-next">CONTINUAR</button>
  </div>
</div>
